module.exports = __webpack_public_path__ + "img/scenes2.5894d884.png";